import React, {FunctionComponent} from 'react'
import {IProps} from './IProps'
import Header from './Header/Header'
import Body from './Body/Body'

const ReportTable: FunctionComponent<IProps> = ({result}) => {

    return (
        <>
            <table className={'table'}>
                <Header />
                <Body result={result} />
            </table>
        </>
    )
}

export default ReportTable
